module.exports = __webpack_public_path__ + "static/media/duka6.b7be72ea.jpg";